<template>
  <div id="myDateShow">
    <div class="title">{{guideImg.id?"修改":"新增"}} 引导页图片</div>
    <div id="dataShow">
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-input v-model="guideImg.imgNo" class="w500" placeholder="编号"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">编号</div>
        <div class="value">
          编号提示：
          1：xxx
          2：xxx
          3：xxx
          4：xxx
          5：xxx
          6：xxx
        </div>
      </div>
      <div class="line">
        <div class="key">提示</div>
        <div class="value">
          <el-input v-model="guideImg.imgName" class="w500" placeholder="请输入图片位置提示：如引导页第一页、第二页等，该标题只是提示，无法生效"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">图片</div>
        <div class="value">
          <el-image v-if="guideImg.imgUrl" :src="guideImg.imgUrl" lazy></el-image>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-upload
                  :headers="headers"
                  ref="upload"
                  :on-change="upLoadAnswer"
                  :on-success="upLoadAnswerSeccess"
                  class="upload-demo"
                  name="multipartFile"
                  drag
                  :action="baseURL+'/guideImg/upload'"
                  :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">重新上传活动海报</div>
          </el-upload>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getGuideImgById, newVue, updateGuideImg} from "../../network/guideImg";

  export default {
    name: "guideImgInsert",
    data(){
      return{
        guideImg: {},
        guideImgId: '',
        headers: {
        },
        baseURL:newVue.baseURL
      }
    },
    created() {
      newVue.obj = this;
      this.authorization=newVue.obj.common.loginInfo.jwtToken;
      this.headers.Authorization = this.authorization;
      this.common.HeaderLocationTwo.href =  "/guideImg/list";
      this.common.HeaderLocationTwo.name =  "引导页管理"
      this.common.HeaderLocationThree.name = "新增/修改引导页消息"
      if (this.$route.params.id!=null){
        this.guideImgId = this.$route.params.id;

        getGuideImgById(this.guideImgId).then(res => {
          this.guideImg = res.data;
        })
      }


    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      upLoadAnswerSeccess(res){
        this.$set(this.guideImg,"imgUrl",res.data);
      },
      upLoadAnswer (file, fileList) {
        this.$refs.upload.submit()
      },
      submit(){
        updateGuideImg(this.guideImg).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
